import styled from 'styled-components';

const ScrollDiv = styled.div`
  position: relative;
  height: 0;
  top: ${({ offset }) => (offset || '0')};
  pointer-events: none;
`;

export default ScrollDiv;



// WEBPACK FOOTER //
// ./src/blocks/ScrollDiv/index.jsx